<div *ngIf="browseTerms && browseTerms.length">
  <div class="browse-data">
    <table class="table table-sm table-hover">
      <thead class="thead">
        <tr>
          <th>Item Call Number</th>
          <th>Title</th>
          <th>Title Count</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let browseTerm of browseTerms; let i = index"
          tabindex="0"
          (agInteract)="search(browseTerm)"
        >
          <td class="w-15">{{ browseTerm.searchTerm }}</td>
          <td class="w-40">{{ browseTerm.title }}</td>
          <td class="w-40">
            [{{ browseTerm.hitCount }} {{ browseTerm.hitCount === 1 ? 'Title' : 'Titles' }}]
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
